<template>
  <vl-grid v-vl-spacer:bottom.medium>
    <vl-column>
      <!-- eslint-disable vue/no-v-html -->
      <p v-html="confirmationMessage || t('general.confirmationMessage')"></p>
      <!-- eslint-enable vue/no-v-html -->
    </vl-column>
  </vl-grid>
  <vl-action-group>
    <vl-button
      :mod-disabled="data.loading"
      :mod-loading="data.loading"
      :mod-error="modError"
      :icon="modError ? 'trash' : ''"
      mod-icon-before
      @click="confirm"
    >
      {{ okLabel || t('general.save') }}
    </vl-button>
    <vl-button
      :mod-disabled="data.loading"
      :mod-loading="data.loading"
      :mod-error="modError"
      icon="cross"
      mod-icon-before
      mod-secondary
      @click="cancel"
    >
      {{ cancelLabel || t('general.cancel') }}
    </vl-button>
  </vl-action-group>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { RouteLocationRaw, useRouter } from 'vue-router';
import { useModalStore } from '@/modules/core/store/modal.store';

const { t } = useI18n();

export type PbsConfirmModalOptions = {
  navigationRouteOnSuccess?: RouteLocationRaw;
  confirm?: (e: any) => Promise<boolean>;
  cancel?: () => Promise<void>;
  okLabel?: string;
  cancelLabel?: string;
  confirmationMessage?: string;
  modError?: boolean;
};

const modalStore = useModalStore();

const props = withDefaults(defineProps<PbsConfirmModalOptions>(), {
  navigationRouteOnSuccess: null,
  confirm: null,
  cancel: null,
  okLabel: null,
  cancelLabel: null,
  confirmationMessage: null,
  modError: false
});

const data = reactive({
  loading: false,
  confirming: false
});

const router = useRouter();

const closedHandler = (evt: any) => {
  if (!data.confirming && props.cancel) {
    props.cancel();
  }
};

onMounted(() => {
  document.addEventListener('closed', closedHandler);
});

onUnmounted(() => {
  document.removeEventListener('closed', closedHandler);
});

const confirm = async (e) => {
  data.confirming = true;
  if (props.confirm) {
    try {
      data.loading = true;
      const isSuccess = await props.confirm(e);
      if (isSuccess && props.navigationRouteOnSuccess) {
        router.push(props.navigationRouteOnSuccess);
      }
    } finally {
      data.loading = false;
    }
  }

  closeModal();
};

const cancel = async () => {
  if (props.cancel) {
    await props.cancel();
  }
  closeModal();
};

const closeModal = () => {
  modalStore.hideModal();
};
</script>

<style lang="scss" scoped></style>
